export const PIE_CHART_COLORS = {
  'MSTEAMS'        : '#6264A7',
  'AUTOMATION'     : '#757575',
  'API'            : '#9cdb8dff',
  'EMAIL'          : 'gray',
  'MESSENGER'      : '#0866ff',
  'INSTAGRAM'      : '#fd6d13',
  'INSTANTCHAT'    : '#74ace1',
  'TELEGRAM'       : '#3390ec',
  'Atendida'       : '#3bae3b',
  'Perdida'        : '#d34c4d',
  'Perdida - Fora de horário': '#b63845',
  'Perdida - Abandono de fila': '#d34c4d',
  'Perdida - Timeout': '#ef6b73',
  'Retida'         : '#3390ec',
  'Transferência'  : '#f78f33',
  'ERRO'           : '#d34c4d',
  'NÃO ENVIADA'    : '#f78f33',
  'SUCESSO'        : '#3bae3b',
  'PENDENTE'       : '#3390ec',
  'RESPONDIDA'     : '#3bae3b',
  'VISUALIZADA'    : '#3390ec',
  'NÃO RESPONDIDA' : '#f78f33',
  'WHATSAPP'       : '#38b127',
  'REENVIADO'      : '#21446C',
  'SMS'            : '#2a7b7b',
  'INSTANTVOICE'   : '#f3b681ff',
  'WHATSAPP_VOICE' : '#4a6e49ff',
  'Voz'            : '#f3b681ff'
};

export const getPieChartColor = (label) => {
  if (label === null || label === undefined)
    return undefined;

  const value = String(label);
  return PIE_CHART_COLORS[value] || PIE_CHART_COLORS[value.toUpperCase()];
};
